// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from lock-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function LockFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15 7a1 1 0 0 1 .993.883L16 8v7a1 1 0 0 1-.883.993L15 16H1a1 1 0 0 1-.993-.883L0 15V8a1 1 0 0 1 .883-.993L1 7h14ZM8 0a5 5 0 0 1 4.995 4.783L13 5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V5a3 3 0 0 0-5.995-.176L5 5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V5a5 5 0 0 1 5-5Z"
      />
    </svg>
  );
}
